import styled from 'styled-components';
import {
  color,
  fontSize,
  fontWeight,
  radius,
  screen,
  shadow,
  spacing
} from '../../theme';

export const StyledLevel = styled.div`
  border-radius: ${radius('md')};
  background-color: ${color('white')};
  box-shadow: ${shadow('md')};
  text-align: left;
  overflow: hidden;
  max-width: 24rem;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: column;

  @media (min-width: ${screen('md')}) {
    max-width: 42rem;
    flex-direction: row;
  }

  @media (min-width: ${screen('lg')}) {
    flex-direction: column;

    &:first-child {
      border-top-left-radius: 80px;
    }

    &:last-child {
      border-top-right-radius: 80px;
    }
  }
`;

export const StyledLevelHeader = styled.div`
  background-color: ${color('midnight_850')};
  text-align: center;
  color: ${color('text_white')};
  padding: ${spacing('xl')} ${spacing('lg')};
  display: flex;
  flex-direction: column;
  position: relative;

  @media (min-width: ${screen('md')}) {
    max-width: 18rem;
    flex-shrink: 0;
  }

  @media (min-width: ${screen('lg')}) {
    max-width: unset;
  }
`;

export const StyledImage = styled.img`
  display: block;
`;

export const StyledTitle = styled.span`
  margin-top: ${spacing('md')};
  font-weight: ${fontWeight('black')};
  text-transform: uppercase;
  letter-spacing: 0.35em;
`;

export const StyledNumber = styled.span`
  position: absolute;
  top: 2.5rem;
  left: 1.75rem;
  width: ${spacing('xl4')};
  height: ${spacing('xl4')};
  border: ${spacing('xs2')} solid ${color('white')};
  background-color: ${color('midnight_800')};
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: ${fontSize('lg')};
  line-height: 1;
  font-weight: ${fontWeight('black')};

  span::before {
    content: '';
    display: block;
    width: ${spacing('lg')};
    height: ${spacing('xs2')};
    background-color: ${color('emerald_200')};
    margin-bottom: ${spacing('xs')};
  }
`;

export const StyledHowTo = styled.div`
  background-color: ${color('emerald_100')};
  color: ${color('emerald_700')};
  font-weight: ${fontWeight('medium')};
  padding: ${spacing('lg')};
  display: flex;
  gap: ${spacing('md')};

  p {
    margin-top: 0;
    margin-bottom: 0;
  }
`;

export const StyledHowToIcon = styled.div`
  color: ${color('emerald_300')};

  svg {
    width: ${spacing('xl')} !important;
    height: ${spacing('xl')} !important;
  }
`;

export const StyledHowToTitle = styled.p`
  text-transform: uppercase;
  font-size: ${fontSize('xs')};
  font-weight: ${fontWeight('black')};
  margin-bottom: ${spacing('xs')} !important;
`;

export const StyledContent = styled.div`
  font-weight: ${fontWeight('medium')};
  padding: ${spacing('lg')};

  ul {
    padding: 0;
    list-style: none;
  }

  li {
    display: flex;
    gap: ${spacing('xs')};

    &:not(:first-child) {
      margin-top: ${spacing('sm')};
    }

    svg {
      color: ${color('text_disabled')};
      width: ${spacing('lg')} !important;
      height: ${spacing('lg')};
    }
  }
`;

export const StyledContentTitle = styled.p`
  text-transform: uppercase;
  color: ${color('text_subtle')};
  font-size: ${fontSize('xs')};
  font-weight: ${fontWeight('black')};
  margin-top: 0;
  margin-bottom: ${spacing('xs')};
`;

export const StyledContentAction = styled.div`
  margin-top: ${spacing('lg')};
`;
